/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const d = (v: string): [string, string] => [v, v];

